import { market } from '../../constants';
import {
  definePhoneNumberToAddressCl,
  getAddressTextCl,
  returnProvidenceIdCl,
} from './AddressesCL';
import {
  definePhoneNumberToAddressPe,
  getAddressTextPe,
  returnProvidenceIdPe,
} from './AddressesPE';
import { APP_SETTINGS } from '../../settings/AppSettings';

const { PERU, CHILE } = APP_SETTINGS.COUNTRIES;

export const createAddressLineText = (address) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return address?.addressLine[0] || null;
    case CHILE.SHORT_NAME:
      return address?.addressLine?.join(', ') || null;
    default:
      return '';
  }
};

export const getLocationTextByCountry = (address, regions) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return getAddressTextPe(address, regions);
    case CHILE.SHORT_NAME:
      return getAddressTextCl(address, regions);
    default:
      return '';
  }
};

const createAddressLineArray = (state) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return [state.street.value.toString(), '', ''];
    case CHILE.SHORT_NAME:
      return [
        state.street.value.toString(),
        state.number.value.toString(),
        state.houseType.value.toString(),
      ];
    default:
      return ['', '', ''];
  }
};

export const returnProvidenceIdByCountry = (address, regions) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return returnProvidenceIdPe(address, regions);
    case CHILE.SHORT_NAME:
      return returnProvidenceIdCl(address, regions);
    default:
      return '';
  }
};

const definePhoneNumberToAddress = (state) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return definePhoneNumberToAddressPe(state);
    case CHILE.SHORT_NAME:
      return definePhoneNumberToAddressCl(state);
    default:
      return {};
  }
};

export const filterState = (address, regions) =>
  regions.filter(function (region) {
    return region.id.toString() === address.state;
  });

export const getProvidencesOfRegion = (regions, id) => {
  const regionFiltered = regions.filter(function (region) {
    return region.id.toString() === id.toString();
  });
  if (!regionFiltered.length) return [];
  return regionFiltered[0].children.map(function (providence) {
    return {
      name: providence.name,
      id: parseInt(providence.id),
    };
  });
};

export const getInitialCities = (regions, regionId, cityId) => {
  const regionFiltered = regions.filter(function (region) {
    return region.id.toString() === regionId.toString();
  });
  if (!regionFiltered.length) return [];
  for (let index = 0; index < regionFiltered[0].children.length; index++) {
    const providence = regionFiltered[0].children[index];
    for (const city of providence.children) {
      if (city.id.toString() === cityId.toString()) {
        return providence.children.map(function (city) {
          return {
            name: city.name,
            id: parseInt(city.id),
          };
        });
      }
    }
  }
  return [];
};

export const getCitiesOfProvidence = (regions, regionId, providenceId) => {
  const regionFiltered = regions.filter(function (region) {
    return region.id.toString() === regionId.toString();
  });
  if (!regionFiltered.length) return [];
  for (let index = 0; index < regionFiltered[0].children.length; index++) {
    const providence = regionFiltered[0].children[index];
    if (providence.id.toString() === providenceId.toString()) {
      return providence.children.map(function (city) {
        return {
          name: city.name,
          id: parseInt(city.id),
        };
      });
    }
  }
  return [];
};

export const firstAddressBody = (state, profile, isPrimary) => {
  return {
    firstName: profile.firstName,
    lastName: profile.lastName,
    state: state.level1.value.toString(),
    city: defineCityToAddress(state),
    phone1: state.phone.value.toString(),
    email1: profile.email1,
    addressLine: createAddressLineArray(state),
    addressType: 'ShippingAndBilling',
    primary: isPrimary.toString(),
  };
};

export const createAddressFormBody = (state, isPrimary, isBilling, email1) => {
  return {
    primary: isPrimary.toString(),
    addressType: isBilling ? 'Billing' : 'ShippingAndBilling',
    nickName: state['addressName'].value.toString(),
    firstName: state['name'].value.toString(),
    lastName: state['lastname'].value.toString(),
    country: market.toUpperCase(),
    state: state['level1'].value.toString(),
    city: defineCityToAddress(state),
    addressLine: createAddressLineArray(state),
    email1: email1,
    ...definePhoneNumberToAddress(state),
  };
};

const defineCityToAddress = (state) =>
  market === PERU.SHORT_NAME
    ? state['level3'].value.toString()
    : state['level2'].value.toString();
